<div>
    <app-iso-cjun-graph></app-iso-cjun-graph>
    <app-abi-graphs></app-abi-graphs>
    <app-echo-graphs></app-echo-graphs>
</div>